/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import UserDto from './UserDto';

/**
 * The SearchingQueryResponseModelUserDto model module.
 * @module model/SearchingQueryResponseModelUserDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelUserDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelUserDto</code>.
     * @alias module:model/SearchingQueryResponseModelUserDto
     */
    constructor() { 
        
        SearchingQueryResponseModelUserDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelUserDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelUserDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelUserDto} The populated <code>SearchingQueryResponseModelUserDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelUserDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [UserDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelUserDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/UserDto>} result
 */
SearchingQueryResponseModelUserDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelUserDto;

